// removed by extract-text-webpack-plugin
module.exports = {"merchantName":"merchantName__3mgF_"};


//////////////////
// WEBPACK FOOTER
// ./components/buyWithInstacredLanding/offersTile/style.css
// module id = 6Abc
// module chunks = 323